import { Controller } from "@hotwired/stimulus"

// Reveals the payment fields only when the activity actually costs money.
// Most do not, and an empty MobilePay field on every form invites people to
// fill one in.
//
// Payment itself needs registration: the organiser's MobilePay number is only
// ever shown to people who signed up, so with no signup list there is nobody
// to show it to. Without registration the whole row is dimmed and disabled.
export default class extends Controller {
  static targets = ["toggle", "panel", "registration", "gate"]

  connect() {
    this.refresh()
  }

  refresh() {
    const allowed = !this.hasRegistrationTarget || this.registrationTarget.checked

    if (!allowed && this.toggleTarget.checked) this.toggleTarget.checked = false

    this.toggleTarget.disabled = !allowed
    if (this.hasGateTarget) {
      this.gateTarget.classList.toggle("opacity-50", !allowed)
      this.gateTarget.classList.toggle("pointer-events-none", !allowed)
    }

    this.panelTarget.classList.toggle("hidden", !this.toggleTarget.checked)
  }
}
